import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { css } from 'styled-components';
import { colorBlue10, colorGrey40, colorGrey50, colorGrey60, colorGrey80 } from '../../../../tokens';
export var getCheckboxOverride = function getCheckboxOverride(_ref) {
  var disabled = _ref.disabled,
      checked = _ref.reallyChecked;
  var result = {};

  if (!checked && !disabled) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            .Checkbox-Checkmark {\n                &:before {\n                    background: ", " !important;\n                }\n            }\n            &:hover {\n                .Checkbox-Checkmark {\n                    &:before {\n                        border-color: ", " !important;\n                    }\n                }\n            }\n        "])), result, colorGrey80, colorBlue10);
  }

  if (disabled) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            .Checkbox-Checkmark {\n                &:before {\n                    border-color: ", " !important;\n                    background-color: ", " !important;\n                }\n                &:after {\n                    color: ", " !important;\n                }\n            }\n        "])), result, colorGrey50, colorGrey60, colorGrey40);
  }

  return result;
};